import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ArrowUp = createReactComponent("ArrowUp", ["svg", defaultAttributes, [["line", {
  x1: "12",
  y1: "19",
  x2: "12",
  y2: "5",
  key: "7jz27h"
}], ["polyline", {
  points: "5 12 12 5 19 12",
  key: "15x67i"
}]]]);
export default ArrowUp;